const TipoQuestaoList = () =>
  import("~/components/Views/Prova/TipoQuestao/List");
const TipoQuestaoNew = () => import("~/components/Views/Prova/TipoQuestao/New");

import auth from "~/middleware/auth";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "/prova" },
  { name: "Administração", link: "/prova/administracao" }
];

export const tipoQuestao = [
  {
    path: "administracao/tipo-questao",
    component: TipoQuestaoList,
    name: "Tipo de Questão",
    meta: {
      title: "Tipo de Questão",
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "administracao/tipo-questao/new",
    component: TipoQuestaoNew,
    name: "Novo Tipo de Questão",
    meta: {
      title: "Novo Tipo de Questão",
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "administracao/tipo-questao/:id",
    component: TipoQuestaoNew,
    name: "Alterar Tipo de Questão",
    meta: {
      title: "Alterar Tipo de Questão",
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/administracao/tipoQuestao.js